import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Cmed from '@/view/record/cmed/Cmed'

export default {
  path: '/research/cmed',
  name: 'ResearchCmed',
  components: {
    default: Cmed,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'research',
    area: 'record-cmed',
    breadcrumb: [
      { name: 'Pesquisa', link: '/research' },
      { name: 'Cmed' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/research/CmedRoute.js